import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/home'
import goods from '@/pages/goods/goods'
import devices from '@/pages/devices/devices'
import reports from '@/pages/reports/reports'
import reportsDetail from '@/pages/reports/reportsDetail'
import channel from '@/pages/reports/channel'
import channelDetail from '@/pages/reports/channelDetail'
import device from '@/pages/reports/device'
import deviceDetail from '@/pages/reports/deviceDetail'
import charts from '@/pages/charts/charts'
import goodsClass from '@/pages/goods/goodsClass'
import devicesDetail from '@/pages/devices/devicesDetail'
import devicesStart from '@/pages/devices/devicesStart'
import devicesUnStart from '@/pages/devices/devicesUnStart'
import devicesImages from '@/pages/devices/devicesImages'
import results from '@/pages/results/results'
import goodsRep from '@/pages/reports/goodsRep'
import classRep from "@/pages/reports/classRep"
import goodsRankDetail from '@/pages/reports/goodsRankDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }, {
      path: '/goods',
      name: 'goods',
      component: goods
    }, {
      path: '/devices',
      name: 'devices',
      component: devices
    }, {
      path: '/reports',
      name: 'reports',
      component: reports
    },{
      path: '/reportsDetail',
      name: 'reportsDetail',
      component: reportsDetail
    }, {
      path: '/channel',
      name: 'channel',
      component: channel
    },{
      path: '/channelDetail',
      name: 'channelDetail',
      component: channelDetail
    },{
      path: '/device',
      name: 'device',
      component: device
    },{
      path: '/deviceDetail',
      name: 'deviceDetail',
      component: deviceDetail
    },{
      path: '/charts',
      name: 'charts',
      component: charts
    }, {
      path: '/goodsClass',
      name: 'goodsClass',
      component: goodsClass
    }, {
      path: '/devicesDetail',
      name: 'devicesDetail',
      component: devicesDetail
    }, {
      path: '/devicesStart',
      name: 'devicesStart',
      component: devicesStart
    }, {
      path: '/devicesUnStart',
      name: 'devicesUnStart',
      component: devicesUnStart
    }, {
      path: '/devicesImages',
      name: 'devicesImages',
      component: devicesImages
    }, {
      path: '/results',
      name: 'results',
      component: results
    }, {
      path: '/goodsRep',
      name: 'goodsRep',
      component: goodsRep
    }, {
      path:'/classRep',
      name:'classRep',
      component: classRep,
    },
    {
      path: '/goodsRankDetail',
      name: 'goodsRankDetail',
      component: goodsRankDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js